import React, { useState } from 'react';
import { LandingChartType } from './LandingCharts';
import HalfDonutGraph from './HalfDonutGraph';
import { dateFormatter, formatToDecimals } from '@lib/helpers/formatting';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { IcoInfoOutline } from '@icons';

interface HalfDonutCardProps {
	chart: LandingChartType;
}

const HalfDonutCard: React.FC<HalfDonutCardProps> = ({ chart }) => {
	const iniaitlHoveredIndex = chart.key === 'execution' ? 0 : 1;

	const [hoveredElementIndex, setHoveredElementIndex] = useState(iniaitlHoveredIndex);

	const extraDataToDisplay =
		chart.extraData?.length > 1
			? chart.extraData
					.map((data: { key: string; value: string }) => {
						switch (data.key) {
							case 'lastDateFtImport':
								return !!data.value
									? {
											...data,
											// label: 'Ultimo caricamento costi esterni',
											label: 'Costi esterni',
											formattedValue: dateFormatter(data.value, 'DD/MM/YYYY'),
											number: chart.extraData.find((data) => data.key === 'lastSalFt').value,
										}
									: null;
							case 'lastDateTsImport':
								return !!data.value
									? {
											...data,
											// label: 'Ultimo caricamento costi interni',
											label: 'Costi interni',
											formattedValue: dateFormatter(data.value, 'DD/MM/YYYY'),
											number: chart.extraData.find((data) => data.key === 'lastSalTs').value,
										}
									: null;
							default:
								return null;
						}
					})
					.filter(Boolean)
			: [];

	return (
		<div
			style={{
				backgroundColor: '#fff',
				padding: '1.5rem',
				borderRadius: '1.5rem',
				minHeight: '340px',
			}}
		>
			<div className="half_donut--grid">
				<div>
					<h4
						style={{
							fontWeight: 700,
						}}
					>
						{chart.title}
					</h4>
					<HalfDonutGraph
						elements={chart.elements}
						hoveredElementIndex={hoveredElementIndex}
						setHoveredElementIndex={setHoveredElementIndex}
					/>
				</div>
				<div
					style={{
						display: 'flex',
						gap: '1.5rem',
						flexDirection: 'column',
						marginTop: extraDataToDisplay.length > 0 ? 0 : '36px',
					}}
				>
					{extraDataToDisplay.length > 0 ? (
						<OverlayTrigger
							placement="top"
							popperConfig={{
								modifiers: [
									{
										name: 'flip',
										enabled: true,
										options: {
											fallbackPlacements: ['bottom'],
											padding: 10,
										},
									},
								],
							}}
							overlay={(props) => {
								return (
									<Tooltip {...props} className={`${props.className} half_donut--extra_data_tooltip`}>
										<div style={{ display: 'grid', gap: '1rem', padding: '1rem .5rem' }}>
											{extraDataToDisplay.map((data) => {
												return (
													<div
														key={data.key}
														style={{
															textAlign: 'left',
														}}
													>
														<div>{data.label}</div>
														<div
															style={{
																fontSize: '12px',
															}}
														>
															<span
																style={{
																	fontWeight: 700,
																}}
															>
																Ultimo caricamento:{' '}
															</span>
															<span>{data.formattedValue}</span>
														</div>
														<div
															style={{
																fontSize: '12px',
															}}
														>
															<span
																style={{
																	fontWeight: 700,
																}}
															>
																N° di SAL:{' '}
															</span>
															<span>{data.number || 'N.D.'}</span>
														</div>
													</div>
												);
											})}
										</div>
									</Tooltip>
								);
							}}
						>
							<IcoInfoOutline
								style={{
									fill: 'var(--np-primary-color)',
									marginLeft: 'auto',
								}}
							/>
						</OverlayTrigger>
					) : null}

					{chart.elements.map((element, index) => (
						<div
							key={element.key}
							onMouseEnter={() => {
								setHoveredElementIndex(index);
							}}
							className="half_donut--element"
						>
							<div
								style={{
									width: '1.5rem',
									height: '1.5rem',
									backgroundColor: element.color,
								}}
							/>

							<span>{element.label}</span>
							<span>{formatToDecimals(element.value)} €</span>
						</div>
					))}
				</div>
				<div className="half_donut--total">
					<span>Totale:</span>
					<span
						style={{
							whiteSpace: 'nowrap',
						}}
					>
						{formatToDecimals(chart.extraData?.find((data) => data.key === 'total')?.value)} €
					</span>
				</div>
			</div>
		</div>
	);
};

export default HalfDonutCard;
